import api from './api';

// Patient onboarding. Staff calls need a login; the two public calls are what
// the patient's link page uses (the practice comes from this deployment's x-db-name).
const onboardingService = {
  // { invites, counts: { awaiting_review, open_links } }
  invites: (all = false) => api.get('/onboarding/invites', { params: { scope: all ? 'all' : undefined } }).then((r) => r.data),
  // Resolves { invite, link, email: { sent, error? } } — a failed email still makes the link.
  invite: (payload) => api.post('/onboarding/invites', payload, { timeout: 60000 }).then((r) => r.data),
  resend: (id) => api.post(`/onboarding/invites/${id}/resend`, null, { timeout: 60000 }).then((r) => r.data),
  cancel: (id) => api.post(`/onboarding/invites/${id}/cancel`).then((r) => r.data),

  // Admin review
  detail: (id) => api.get(`/onboarding/invites/${id}`).then((r) => r.data),
  approve: (id, note) => api.post(`/onboarding/invites/${id}/approve`, { note }).then((r) => r.data),
  reject: (id, note) => api.post(`/onboarding/invites/${id}/reject`, { note }).then((r) => r.data),
  // An object URL for an uploaded document (the request carries the login, a plain <img src> couldn't).
  documentUrl: async (documentId) => {
    const r = await api.get(`/onboarding/documents/${documentId}`, { responseType: 'blob' });
    return URL.createObjectURL(r.data);
  },

  // Public (the patient)
  publicLoad: (token) => api.get(`/public/onboarding/${encodeURIComponent(token)}`).then((r) => r.data),
  publicSubmit: (token, payload) => api.post(`/public/onboarding/${encodeURIComponent(token)}`, payload, { timeout: 120000 }).then((r) => r.data),
};

export default onboardingService;
